import React from 'react';
import Layout from '../components/layout/Layout';

const Datenschutz: React.FC = () => {
  React.useEffect(() => {
    document.title = "Datenschutz | OetterliApps";
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-20 mt-16">
        <h1 className="text-3xl font-bold mb-8 text-sky-800">Datenschutzerklärung</h1>
        
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-xl font-semibold mb-4 text-sky-700">1. Datenschutz auf einen Blick</h2>
          
          <h3 className="text-lg font-medium mb-2 text-sky-600">Allgemeine Hinweise</h3>
          <p className="mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
            wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
            werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text 
            aufgeführten Datenschutzerklärung.
          </p>
          
          <h3 className="text-lg font-medium mb-2 mt-6 text-sky-600">Datenerfassung auf dieser Website</h3>
          <h4 className="font-medium mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
          <p className="mb-4">
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
            können Sie dem Impressum dieser Website entnehmen.
          </p>
          
          <h4 className="font-medium mb-2">Wie erfassen wir Ihre Daten?</h4>
          <p className="mb-4">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, 
            die Sie in ein Kontaktformular eingeben.
          </p>
          <p className="mb-4">
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. 
            Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). 
            Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
          </p>
          
          <h4 className="font-medium mb-2">Wofür nutzen wir Ihre Daten?</h4>
          <p className="mb-4">
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
            Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>
          
          <h4 className="font-medium mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
          <p className="mb-4">
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten 
            personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten 
            zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit 
            für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der 
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">2. Hosting</h2>
          <p className="mb-4">
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
          </p>
          
          <h3 className="text-lg font-medium mb-2 text-sky-600">Externes Hosting</h3>
          <p className="mb-4">
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, 
            werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, 
            Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, 
            die über eine Website generiert werden, handeln.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">3. Allgemeine Hinweise und Pflichtinformationen</h2>
          
          <h3 className="text-lg font-medium mb-2 text-sky-600">Datenschutz</h3>
          <p className="mb-4">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
            personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie 
            dieser Datenschutzerklärung.
          </p>
          
          <h3 className="text-lg font-medium mb-2 mt-6 text-sky-600">Hinweis zur verantwortlichen Stelle</h3>
          <p className="mb-4">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="mb-4">
            OetterliApps<br />
            Patrick Oetterli<br />
            Sappetenstrasse 14<br />
            4416 Bubendorf<br />
            Schweiz<br /><br />
            Telefon: +41 123 456 789<br />
            E-Mail: patrick.oetterli@gmail.com
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Datenschutz;
